'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = undefined;

var _reactI18next = require('react-i18next');

var translate = exports.translate = (0, _reactI18next.withTranslation)('application-bootstrapper', { withRef: true });


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/translateUtils.js
// module id = 717
// module chunks = 118